// src/pages/CompanyGroTemplatesPage.tsx
import { NavLink, Outlet } from "react-router-dom";

import { PageHeader } from "@/components/shared/PageHeader";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "riscos", label: "Riscos" },
  { to: "dimensoes", label: "Dimensões" },
  { to: "dimensoes-riscos", label: "Dimensões x Riscos" },
  { to: "planos", label: "Planos e Ações" },
  { to: "riscos-planos", label: "Riscos x Planos" },
  { to: "planos-por-regra", label: "Planos por Regra" },
] as const;

export default function CompanyGroTemplatesPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Estrutura GRO da Empresa"
        description="Gerencie os modelos reutilizáveis da Empresa com a mesma experiência usada na operação dos Clientes."
      />

      <nav
        aria-label="Cadastros da Estrutura GRO da Empresa"
        className="flex max-w-full gap-1 overflow-x-auto rounded-xl border border-border bg-card p-1.5 shadow-sm"
      >
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              cn(
                "inline-flex h-10 shrink-0 items-center justify-center rounded-lg border px-4 text-sm font-semibold transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                isActive
                  ? "border-primary bg-primary text-primary-foreground shadow-sm hover:bg-primary/90"
                  : "border-transparent bg-transparent text-foreground hover:border-border hover:bg-muted dark:text-foreground dark:hover:bg-muted/80",
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
